import {
    Directive,
    effect,
    ElementRef,
    HostListener,
    inject,
    input,
    output,
    OutputEmitterRef,
} from '@angular/core';

@Directive({
    selector: '[iqBuilderLabeLTruncate]',
    standalone: true,
})
export class IqBuilderLabelTruncateDirective {
    truncate = input<boolean>(false);

    constructor() {
        effect(() => {
            const target: HTMLElement = this._el.nativeElement || {
                offSetWidth: 0,
                scrollWidth: 0,
            };
            const isEllipsed = target.offsetWidth < target.scrollWidth;

            this.isTruncated.emit(this.truncate() && isEllipsed);
        });
    }

    private _el: ElementRef = inject(ElementRef);

    isTruncated: OutputEmitterRef<boolean> = output<boolean>();

    // @HostListener('mouseover') onMouseOver() {
    //     const target: HTMLElement = this._el.nativeElement || {
    //         offSetWidth: 0,
    //         scrollWidth: 0,
    //     };
    //     const isEllipsed = target.offsetWidth < target.scrollWidth;

    //     this.isTruncated.emit(isEllipsed);
    // }

    // @HostListener('click') onClick() {
    //     const target: HTMLElement = this._el.nativeElement || {
    //         offSetWidth: 0,
    //         scrollWidth: 0,
    //     };
    //     const isEllipsed = target.offsetWidth < target.scrollWidth;

    //     this.isTruncated.emit(isEllipsed);
    // }
}
